import { Box, Button, Grid, Link, Typography } from "@mui/material";

export default function ContractsModal({ data }) {
  return (
    <Grid container spacing={2}>
      {data?.map((item, idx) => (
        <>
          <Grid item xs={12}>
            <Typography variant="body2">{item.name_contract}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Link href={item.contract_url} target={"_blank"}>
              <Button variant="contained" fullWidth>
                {"Ver"}
              </Button>
            </Link>
            <Box mb={2} />
          </Grid>
        </>
      ))}
    </Grid>
  );
}
